const ToolsPartsTransfer = {

    "tools_parts_transfer": "Tools & Parts Transfer",
    "service_department": "Service Department",
    "remarks": "Remarks",
    "select_item": "Select Tools / Parts",
    "search": "Search",

    "list_title": "Tools & Parts Transfer",
    "filter_title": "Tools & Parts Transfer Filter",
    "details_title": "Tools & Parts Transfer Details",

    "table_transfer_code": "Transfer Code",
    "table_service_department": "Service Department",
    "table_items": "Assigned Items",
    "table_item": "Item",
    "table_type": "Type",
    "table_remaining": "Remaining Qty",
    "table_quantity": "Assign Qty",
    "table_date": "Issue Date",
    "table_status": "Status",
    "table_remarks": "Remarks",

    "error_service_department": "Select Service Department",
    "error_item": "Select Item",
    "error_quantity": "Enter Quantity",
}

export default ToolsPartsTransfer;
